import Auth from '../auth/Auth';
import CustomerBlock from "../models/CustomerBlock";
import { WebClient } from './WebClient'

class ApiCustomerBlock extends WebClient {
    async getCustomerBlocks(): Promise<CustomerBlock[] | null> {
        let url = "/customer/block"

        return this.get(url, Auth.getAuthToken()).then(res => {
            if (res.status === 200) {
                return res.data;
            }
            return null;
        }).catch(() => { return null; });
    }

    async updateCustomerBlock(data: CustomerBlock): Promise<boolean> {
        return this.post("/customer/block", data, Auth.getAuthToken()).then(res => {
            return res.status === 200;
        }).catch((e) => {
            return false;
        });
    }

    async deleteCustomerBlock(companyEmployedId: string): Promise<boolean> {
        return this.delete(`/customer/block/${companyEmployedId}`, Auth.getAuthToken()).then(res => {
            return (res.status === 200);
        }).catch((e) => { return false; });
    }
}

export default new ApiCustomerBlock();
